import { useEffect, useState } from 'react';
import './historyBtn.scss';
import imgUrlFocus from '../../../assets/img/allHistory_h.png';
import imgUrlBlur from '../../../assets/img/allHistory_s.png';
import { useCustomTranslation } from '@/hooks/useCustomTranslation';

export default function posterForColumn(props) {
  const [posterInfo, updatePosterInfo] = useState({
    isChecked: false,
    isFocus: props.posterBox.posterArr.isFocus,
    indexValue: 0,
    posterAtion: undefined,
  });

  useEffect(() => {
    const {
      posterBox: { posterAnimation, posterIndex, posterArr: { isFocus } },
      isChecked,
    } = props;
    updatePosterInfo({
      isChecked,
      isFocus,
      indexValue: posterIndex,
      posterAtion: posterAnimation,
    });
  }, []);

  useEffect(() => {
    const {
      posterBox: { posterArr },
      // flag,
      isChecked,
    } = props;
    updatePosterInfo(posterInfo => ({
      ...posterInfo,
      isChecked,
      isFocus: posterArr.isFocus,
    }));
  }, [props.isChecked, props.posterBox.posterArr.isFocus]);

  const { t } = useCustomTranslation();

  return (
    <span
      style={{ color: 'transparent' }}
    >
      <div
        className={[
          'allHistoryBtn',
          posterInfo.posterAtion === posterInfo.indexValue ? 'allHistoryBtnShake' : null,
        ].join(' ')}
      >
        <img className="allHistoryBtnImg" src={posterInfo.isFocus && posterInfo.isChecked ? imgUrlFocus : imgUrlBlur} alt="" />
        <span className="allHistoryBtnTitle">{t('全部历史')}</span>
      </div>
    </span>
  );
}
